import React, { ChangeEvent, memo, useMemo } from 'react';
import * as Styled from './styled';
import {
  Paginator,
  SelectOption,
  Input,
} from '@leasequery/lq.react-component-library';
import TablePageSizer from '../table-page-sizer/TablePageSizer';
import { noop } from '../../../util';
import { StringOrComponent } from '../../../models';

const DEFAULT_LABELS = {
  searchPlaceHolder: 'Begin typing to search',
};

interface TableHeaderProps {
  itemCount: number;
  pageSize: number;
  pageIndex: number;
  displayedRange?: number;
  globalFilter?: string;
  singlePageView: boolean;
  labels?: {
    itemCount?: StringOrComponent;
    perPage?: string;
    showing?: string;
    searchPlaceHolder?: string;
  };
  onPageSizeChange?: (item: SelectOption<number>) => void;
  onPageinatorClick?: (pageIndex: number) => void;
  onGlobalFilterChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

function TableHeader({
  itemCount,
  pageSize,
  pageIndex,
  displayedRange,
  globalFilter,
  labels,
  onPageSizeChange,
  onPageinatorClick,
  onGlobalFilterChange,
  singlePageView,
}: TableHeaderProps): JSX.Element {
  const labelsText = useMemo(() => ({ ...DEFAULT_LABELS, ...labels }), [
    labels,
  ]);
  return (
    <Styled.TableHeader>
      <Input
        name="globalFilter"
        value={globalFilter}
        onChange={onGlobalFilterChange}
        placeholder={labelsText.searchPlaceHolder}
        variant="search"
      />
      {!singlePageView && (
        <>
          <TablePageSizer
            itemCount={itemCount}
            pageSize={pageSize}
            pageIndex={pageIndex}
            labels={labelsText}
            onChange={onPageSizeChange}
          />
          {itemCount > 0 && (
            <Paginator
              pageSize={pageSize}
              pageIndex={pageIndex}
              displayedRange={displayedRange}
              itemCount={itemCount}
              onClick={onPageinatorClick}
            />
          )}
        </>
      )}
    </Styled.TableHeader>
  );
}

TableHeader.defaultProps = {
  displayedRange: 10,
  globalFilter: '',
  labels: DEFAULT_LABELS,
  onPageSizeChange: noop,
  onPageinatorClick: noop,
  onGlobalFilterChange: noop,
};

export default memo(TableHeader);
